export const hotTopics = [
  { id: 1, rank: 1, title: "顶流综艺录制现场出大瓜？幕后真相网友吵翻天", heat: 128.6, tag: "娱乐", isNew: true },
  { id: 2, rank: 2, title: "某剧组深夜被拍到全员冷脸，制片方紧急回应", heat: 96.3, tag: "剧集", isNew: true },
  { id: 3, rank: 3, title: "选秀回锅肉二次翻红，粉丝与路人上演在线对线", heat: 82.1, tag: "选秀", isNew: false },
  { id: 4, rank: 4, title: "主播连麦翻车名场面盘点，笑不活了", heat: 67.9, tag: "直播", isNew: false },
  { id: 5, rank: 5, title: "代言合约到期引猜测，品牌方一句文案成爆梗", heat: 54.7, tag: "商业", isNew: false },
  { id: 6, rank: 6, title: "新剧评分两极分化，观众站队开始拉锯战", heat: 43.2, tag: "剧集", isNew: true },
  { id: 7, rank: 7, title: "素人逆袭成顶流，十年旧照被考古上热搜", heat: 31.8, tag: "娱乐", isNew: false },
];

export const liveRooms = [
  {
    id: 1,
    name: "蹲后续：今晚这瓜到底熟没熟",
    host: "瓜田李下",
    viewers: "12.8万",
    online: true,
    category: "娱乐",
    hot: 9999,
    cover:
      "https://readdy.ai/api/search-image?query=a%20colorful%20energetic%20live%20streaming%20studio%20with%20vibrant%20watermelon%20red%20and%20lime%20green%20neon%20lights%2C%20modern%20broadcast%20desk%20with%20microphone%20and%20ring%20light%2C%20cheerful%20playful%20atmosphere%2C%20warm%20lighting%2C%20clean%20and%20bright%20interior&width=800&height=450&seq=live-01&orientation=landscape",
  },
  {
    id: 2,
    name: "老瓜农来聊综艺背后的生存法则",
    host: "隔壁老王说事",
    viewers: "8.6万",
    online: true,
    category: "行业",
    hot: 8841,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20podcast%20talk%20show%20set%20with%20sofa%20and%20table%20lamp%2C%20two%20armchairs%2C%20plant%20decorations%2C%20soft%20golden%20lighting%2C%20casual%20conversation%20ambience%2C%20inviting%20and%20friendly&width=800&height=450&seq=live-02&orientation=landscape",
  },
  {
    id: 3,
    name: "弹幕鉴瓜局：你猜这波谁赢了",
    host: "吃瓜少女vivi",
    viewers: "6.2万",
    online: true,
    category: "综合",
    hot: 7210,
    cover:
      "https://readdy.ai/api/search-image?query=trendy%20young%20female%20streamer%20studio%20in%20pink%20and%20coral%20tones%20with%20stuffed%20toys%2C%20glowing%20signboard%2C%20pop%20style%20decor%2C%20playful%20and%20energetic%2C%20bright%20studio%20lights&width=800&height=450&seq=live-03&orientation=landscape",
  },
  {
    id: 4,
    name: "深夜电台：说说那些让你血压飙升的剧情",
    host: "瓜友电台FM",
    viewers: "4.9万",
    online: true,
    category: "深夜",
    hot: 5902,
    cover:
      "https://readdy.ai/api/search-image?query=calm%20late%20night%20radio%20broadcast%20room%20with%20retro%20microphone%2C%20moody%20amber%20and%20warm%20bokeh%20lights%2C%20vinyl%20records%20on%20wall%2C%20cozy%20dim%20atmosphere&width=800&height=450&seq=live-04&orientation=landscape",
  },
  {
    id: 5,
    name: "连麦现场：粉丝和黑粉坐下来聊聊",
    host: "理性看瓜团",
    viewers: "3.5万",
    online: true,
    category: "连麦",
    hot: 4687,
    cover:
      "https://readdy.ai/api/search-image?query=modern%20video%20call%20grid%20layout%20with%20multiple%20round%20profile%20avatars%2C%20green%20and%20white%20clean%20broadcast%20ui%2C%20professional%20multi%20guest%20live%20streaming%20background&width=800&height=450&seq=live-05&orientation=landscape",
  },
  {
    id: 6,
    name: "考古时间线：那对CP的十年意难平",
    host: "显微镜磕糖部",
    viewers: "2.1万",
    online: false,
    category: "CP",
    hot: 3125,
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20memory%20scrapbook%20collage%20aesthetic%20with%20vintage%20photo%20frames%20and%20polaroids%2C%20soft%20pastel%20tapes%2C%20dreamy%20warm%20light%2C%20sweet%20retro%20feeling&width=800&height=450&seq=live-06&orientation=landscape",
  },
];

export const danmakuSeed = [
  { id: 1, text: "前排吃瓜！", color: "primary" },
  { id: 2, text: "这瓜保熟吗哈哈", color: "accent" },
  { id: 3, text: "蹲一个后续反转", color: "secondary" },
  { id: 4, text: "笑死，真的绷不住了", color: "primary" },
  { id: 5, text: "我站队楼主，有道理", color: "accent" },
  { id: 6, text: "啊啊啊这也太抓马了吧", color: "secondary" },
  { id: 7, text: "前方高能预警", color: "primary" },
  { id: 8, text: "已截图保存吃瓜凭证", color: "accent" },
];

export const connectTopics = [
  { id: 1, title: "聊聊那些被捶的代言人", tag: "娱乐", viewers: "3.2万", slots: "还差 2 席" },
  { id: 2, title: "新剧男二凭什么比男主还出圈", tag: "剧集", viewers: "2.8万", slots: "排队中" },
  { id: 3, title: "选秀人气机制到底公不公平", tag: "选秀", viewers: "2.1万", slots: "还差 5 席" },
  { id: 4, title: "塌房前的 10 个预警信号", tag: "知识", viewers: "1.9万", slots: "已满" },
  { id: 5, title: "素人走红之后会变吗", tag: "综合", viewers: "1.6万", slots: "还差 3 席" },
  { id: 6, title: "考古旧物料到底算不算挖隐私", tag: "争议", viewers: "1.3万", slots: "已满" },
];

export const categories = [
  { id: 1, name: "娱乐八卦", desc: "顶流、塌房、恋情与作品，一条龙蹲到反转", icon: "ri-vip-crown-line", color: "primary" },
  { id: 2, name: "剧集吐槽", desc: "新剧老剧的评分、剧情与角色，边看边吐", icon: "ri-movie-2-line", color: "accent" },
  { id: 3, name: "选秀江湖", desc: "舞台高光与幕后花絮，见证人气沉浮", icon: "ri-mic-line", color: "secondary" },
  { id: 4, name: "直播名场面", desc: "连麦翻车与神级操作，快乐源泉不断更", icon: "ri-live-line", color: "primary" },
  { id: 5, name: "商业瓜田", desc: "代言、版权与资本操作，看得懂的门道", icon: "ri-exchange-funds-line", color: "accent" },
  { id: 6, name: "CP 宇宙", desc: "显微镜磕糖与考古时间线，甜甜的都在这里", icon: "ri-heart-line", color: "secondary" },
];

export const testimonials = [
  { id: 1, name: "资深瓜友·柠檬汽水", text: "以前都是到处找二手瓜，现在打开就能看直播讨论，弹幕里全是同好，追反转真的爽。", rating: 5 },
  { id: 2, name: "路人转粉·没刺的鱼", text: "连麦环节最上头，大家观点不一样但能好好说话，讲逻辑讲证据，比评论区吵架有营养。", rating: 5 },
  { id: 3, name: "佛系围观·一颗蛋", text: "界面干净不花哨，热榜更新快，蹲了很久的后续还真让我等到了，体验很舒服。", rating: 4 },
];

export const faqs = [
  { id: 1, q: "吃瓜频道的直播互动是怎么玩的？", a: "你可以进入任意直播间在线围观，直播间内配有实时讨论区和弹幕。想看更多观点时，可以申请连麦上麦，与主播和其他瓜友边聊边理清事件脉络，共同追后续、蹲反转。" },
  { id: 2, q: "弹幕和连麦有什么使用门槛吗？", a: "没有门槛。进入直播间即可发送弹幕参与讨论，连麦功能通常在主播开启接听位后开放，点击想连麦排队即可，轮到你时会有提示。" },
  { id: 3, q: "频道里的瓜是怎么保证可信度的？", a: "我们只围绕公开信息、官方回应与可信来源展开讨论，主播会引导大家区分实锤与猜测，遇到尚未证实的内容会明确标注，倡导理性吃瓜。" },
  { id: 4, q: "深夜还有内容可以看吗？", a: "当然。频道设有深夜电台等长播节目，适合睡前来一场轻松的剧情与八卦盘点，不同时段都能找到在线围观的直播现场。" },
  { id: 5, q: "我自己也能开一个吃瓜直播间吗？", a: "可以的。只要你有稳定的话题与真诚的表达，就可以申请成为频道主播，我们欢迎有理有据、观点鲜明的新鲜声音加入。" },
  { id: 6, q: "有社区规范需要注意什么吗？", a: "请尊重事实、尊重当事人，禁止人身攻击与未经证实的恶意造谣。我们倡导瓜可以吃但要吃得体面，违规内容将被处理。" },
];